import { render } from "./PagoPublico.vue?vue&type=template&id=8f811910"
import script from "./PagoPublico.vue?vue&type=script&lang=js"
export * from "./PagoPublico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__